import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';

interface SettingsItemProps extends React.InputHTMLAttributes<HTMLInputElement> {
  errors?: string;
  title?: string;
  touched?: boolean;
  name?: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onClick?: (...args: any) => void;
}

function SettingsItem({
  errors,
  title,
  touched,
  onChange,
  onClick,
  name,
  value,
  ...otherProps
}: SettingsItemProps) {
  return (
    <div className="w-full">
      <div className="text-text-400">{title}</div>
      <div>
        <Input onChange={onChange} name={name} value={value} {...otherProps} />
        {errors && touched && <div className="text-sm text-destructive">{errors}</div>}
      </div>
      {onClick && (
        <div className="flex justify-end mt-1">
          <Button variant="ghost" type="submit" onClick={onClick}>
            <div className="text-sm text-main">Save</div>
          </Button>
        </div>
      )}
    </div>
  );
}

export default SettingsItem;
